import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** SUBMITTED → COMPLETED。body 僅 updatedAt。 */
export async function approveStockIssue(id, payload = {}) {
  const { data: raw } = await request.post(
    `/ims/stock-issue/${id}/approve`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
